document.documentElement.classList.remove('no-js');

const kvTheme = window.KVShopTheme || {};

const kvRoute = (path) => {
  const rootUrl = kvTheme.rootUrl || '/';
  return `${rootUrl.replace(/\/$/, '')}/${String(path).replace(/^\//, '')}`;
};

const kvFormatMoney = (cents) => {
  const value = Number(cents || 0) / 100;
  try {
    return new Intl.NumberFormat(document.documentElement.lang || 'tr-TR', {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'TRY'
    }).format(value);
  } catch (error) {
    return `${value.toFixed(2)} TL`;
  }
};

const kvEscapeHtml = (value = '') => String(value)
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;')
  .replace(/'/g, '&#039;');

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-mobile-menu-toggle]');
  if (!trigger) return;

  const drawer = document.querySelector('[data-mobile-menu]');
  if (!drawer) return;

  const expanded = trigger.getAttribute('aria-expanded') === 'true';
  trigger.setAttribute('aria-expanded', String(!expanded));
  drawer.hidden = expanded;
});

document.addEventListener('click', (event) => {
  const tabButton = event.target.closest('[data-kv-tab]');
  if (!tabButton) return;

  const tabs = tabButton.closest('[data-kv-tabs]');
  if (!tabs) return;

  const tabId = tabButton.getAttribute('data-kv-tab');
  tabs.querySelectorAll('[data-kv-tab]').forEach((button) => {
    const active = button === tabButton;
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-selected', String(active));
  });
  tabs.querySelectorAll('[data-kv-tab-panel]').forEach((panel) => {
    panel.classList.toggle('is-active', panel.getAttribute('data-kv-tab-panel') === tabId);
  });
});

const kvInitCarousels = (scope = document) => {
  scope.querySelectorAll('[data-kv-carousel-shell]').forEach((shell) => {
    const carousel = shell.querySelector('[data-kv-carousel]');
    const prev = shell.querySelector('[data-kv-carousel-prev]');
    const next = shell.querySelector('[data-kv-carousel-next]');
    const root = shell.closest('.shopify-section') || shell.parentElement;
    const dots = root?.querySelector('[data-kv-carousel-dots]');
    if (!carousel || !prev || !next || !dots || carousel.dataset.kvCarouselReady === 'true') return;

    carousel.dataset.kvCarouselReady = 'true';

    const getPageCount = () => Math.max(1, Math.ceil(carousel.scrollWidth / Math.max(carousel.clientWidth, 1)));
    const getActivePage = () => {
      const maxScroll = Math.max(carousel.scrollWidth - carousel.clientWidth, 1);
      return Math.round((carousel.scrollLeft / maxScroll) * (getPageCount() - 1));
    };
    const scrollToPage = (page) => {
      const pageCount = getPageCount();
      const maxScroll = Math.max(carousel.scrollWidth - carousel.clientWidth, 0);
      const nextPage = Math.max(0, Math.min(page, pageCount - 1));
      const left = pageCount <= 1 ? 0 : (maxScroll / (pageCount - 1)) * nextPage;
      carousel.scrollTo({ left, behavior: 'smooth' });
    };
    const update = () => {
      const pageCount = getPageCount();
      const activePage = getActivePage();
      prev.disabled = activePage <= 0;
      next.disabled = activePage >= pageCount - 1;
      shell.classList.toggle('is-static', pageCount <= 1);

      if (dots.childElementCount !== pageCount) {
        dots.replaceChildren(...Array.from({ length: pageCount }, (_, index) => {
          const dot = document.createElement('button');
          dot.className = 'kv-carousel-dot';
          dot.type = 'button';
          dot.setAttribute('aria-label', `Vitrin sayfası ${index + 1}`);
          dot.addEventListener('click', () => scrollToPage(index));
          return dot;
        }));
      }

      dots.querySelectorAll('.kv-carousel-dot').forEach((dot, index) => {
        dot.classList.toggle('is-active', index === activePage);
      });
    };

    prev.addEventListener('click', () => scrollToPage(getActivePage() - 1));
    next.addEventListener('click', () => scrollToPage(getActivePage() + 1));
    carousel.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', update);
    update();
  });
};

document.addEventListener('DOMContentLoaded', () => kvInitCarousels());
document.addEventListener('shopify:section:load', (event) => kvInitCarousels(event.target));

const kvInitHeroSliders = (scope = document) => {
  scope.querySelectorAll('[data-kv-hero-slider]').forEach((hero) => {
    const slides = [...hero.querySelectorAll('[data-kv-hero-slide]')];
    const dots = hero.querySelector('[data-kv-hero-dots]');
    if (!dots || slides.length <= 1 || hero.dataset.kvHeroReady === 'true') return;

    hero.dataset.kvHeroReady = 'true';
    let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
    if (activeIndex < 0) activeIndex = 0;
    let timer = null;

    const setActive = (index) => {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === activeIndex);
      });
      dots.querySelectorAll('.kv-hero-dot').forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === activeIndex);
      });
    };
    const start = () => {
      window.clearInterval(timer);
      timer = window.setInterval(() => setActive(activeIndex + 1), 5200);
    };

    dots.replaceChildren(...slides.map((_, index) => {
      const dot = document.createElement('button');
      dot.className = 'kv-hero-dot';
      dot.type = 'button';
      dot.setAttribute('aria-label', `Hero slaytı ${index + 1}`);
      dot.addEventListener('click', () => {
        setActive(index);
        start();
      });
      return dot;
    }));

    hero.addEventListener('mouseenter', () => window.clearInterval(timer));
    hero.addEventListener('mouseleave', start);
    setActive(activeIndex);
    start();
  });
};

document.addEventListener('DOMContentLoaded', () => kvInitHeroSliders());
document.addEventListener('shopify:section:load', (event) => kvInitHeroSliders(event.target));

document.addEventListener('click', (event) => {
  const thumb = event.target.closest('[data-media-thumb]');
  if (!thumb) return;

  const gallery = thumb.closest('[data-product-gallery]');
  if (!gallery) return;

  const mediaId = thumb.getAttribute('data-media-thumb');
  const stage = gallery.querySelector('[data-gallery-stage]');
  if (!stage) return;

  const template = gallery.querySelector(`template[data-gallery-template="${mediaId}"]`);
  if (template) {
    stage.innerHTML = template.innerHTML;
  } else if (thumb.dataset.gallerySrc) {
    const image = document.createElement('img');
    image.src = thumb.dataset.gallerySrc;
    if (thumb.dataset.gallerySrcset) image.srcset = thumb.dataset.gallerySrcset;
    image.sizes = '(min-width: 990px) 55vw, 100vw';
    image.alt = thumb.dataset.galleryAlt || '';
    image.loading = 'eager';
    stage.replaceChildren(image);
  }

  gallery.querySelectorAll('[data-media-thumb]').forEach((button) => {
    button.classList.toggle('is-active', button === thumb);
  });
});

document.addEventListener('change', (event) => {
  const sort = event.target.closest('[data-sort-by]');
  if (!sort) return;

  const url = new URL(window.location.href);
  url.searchParams.set('sort_by', sort.value);
  window.location.href = url.toString();
});

const kvCloseCollectionFilters = (root) => {
  if (!root) return;
  const panel = root.querySelector('[data-collection-filter-panel]');
  const backdrop = root.querySelector('.kv-filter-backdrop');
  const opener = document.querySelector(`[aria-controls="${panel?.id || ''}"]`);

  root.classList.remove('is-filter-open');
  if (backdrop) backdrop.hidden = true;
  if (opener) opener.setAttribute('aria-expanded', 'false');
  document.body.classList.remove('kv-filter-drawer-open');
  opener?.focus();
};

document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-collection-filter-open]');
  if (opener) {
    const panel = document.getElementById(opener.getAttribute('aria-controls'));
    const root = panel?.closest('[data-collection-filters]');
    const backdrop = root?.querySelector('.kv-filter-backdrop');
    if (!root || !panel || !backdrop) return;

    root.classList.add('is-filter-open');
    backdrop.hidden = false;
    opener.setAttribute('aria-expanded', 'true');
    document.body.classList.add('kv-filter-drawer-open');
    panel.querySelector('[data-collection-filter-close]')?.focus();
    return;
  }

  const closer = event.target.closest('[data-collection-filter-close]');
  if (closer) {
    kvCloseCollectionFilters(closer.closest('[data-collection-filters]'));
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  kvCloseCollectionFilters(document.querySelector('[data-collection-filters].is-filter-open'));
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('.kv-product-form');
  if (!form) return;

  const submitter = event.submitter;
  if (!submitter || !submitter.classList.contains('kv-add-cart-main')) return;

  const bundleInputs = [...document.querySelectorAll('[data-bundle-variant-id]:checked')]
    .map((input) => input.getAttribute('data-bundle-variant-id'))
    .filter(Boolean);

  if (!bundleInputs.length) return;

  const mainVariant = form.querySelector('[name="id"]')?.value;
  const quantity = Number(form.querySelector('[name="quantity"]')?.value || 1);
  if (!mainVariant) return;

  event.preventDefault();
  submitter.disabled = true;

  try {
    const items = [
      { id: Number(mainVariant), quantity: Math.max(quantity, 1) },
      ...bundleInputs.map((id) => ({ id: Number(id), quantity: 1 }))
    ];

    const response = await fetch(kvTheme.cartAddUrl || kvRoute('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items })
    });

    if (!response.ok) throw new Error('Cart add failed');
    window.location.href = kvTheme.cartUrl || kvRoute('cart');
  } catch (error) {
    submitter.disabled = false;
    form.submit();
  }
});

document.addEventListener('click', async (event) => {
  const quickButton = event.target.closest('[data-quick-view-url]');
  if (!quickButton) return;

  event.preventDefault();
  const fallbackProductUrl = quickButton.getAttribute('data-product-url')
    || quickButton.closest('.kv-product-card')?.querySelector('a[href]')?.getAttribute('href')
    || '#';
  const shouldOpenProductPage = window.matchMedia('(max-width: 749px)').matches && (navigator.maxTouchPoints || 0) > 0;
  if (shouldOpenProductPage && fallbackProductUrl !== '#') {
    window.location.href = fallbackProductUrl;
    return;
  }

  const drawer = document.querySelector('[data-quick-drawer]');
  const content = drawer?.querySelector('[data-quick-content]');
  if (!drawer || !content) {
    if (fallbackProductUrl !== '#') window.location.href = fallbackProductUrl;
    return;
  }

  drawer.hidden = false;
  content.innerHTML = `<div class="kv-editor-empty"><strong>${kvEscapeHtml(kvTheme.loadingProductLabel || 'Ürün yükleniyor')}</strong><span>${kvEscapeHtml(kvTheme.loadingNoteLabel || 'Lütfen bekleyin.')}</span></div>`;

  try {
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 8000);
    const response = await fetch(quickButton.getAttribute('data-quick-view-url'), {
      headers: { Accept: 'application/json' },
      signal: controller.signal
    });
    window.clearTimeout(timeout);
    if (!response.ok) throw new Error('Product fetch failed');

    const product = await response.json();
    const firstVariant = product.variants.find((variant) => variant.available) || product.variants[0];
    const image = product.featured_image || (product.images && product.images[0]) || '';
    const variantOptions = product.variants.map((variant) => (
      `<option value="${variant.id}" data-price="${variant.price}" ${variant.id === firstVariant.id ? 'selected' : ''} ${variant.available ? '' : 'disabled'}>${kvEscapeHtml(variant.title)} - ${kvFormatMoney(variant.price)}</option>`
    )).join('');

    const productUrl = product.url || (product.handle ? kvRoute(`products/${product.handle}`) : '#');

    content.innerHTML = `
      <div class="kv-quick-product">
        ${image ? `<img src="${kvEscapeHtml(image)}" alt="${kvEscapeHtml(product.title)}">` : ''}
        <div>
          ${product.vendor ? `<p class="kv-eyebrow">${kvEscapeHtml(product.vendor)}</p>` : ''}
          <h2>${kvEscapeHtml(product.title)}</h2>
          <div class="kv-price-row"><span class="kv-price" data-quick-price>${kvFormatMoney(firstVariant.price)}</span></div>
        </div>
        <form class="kv-quick-form" data-quick-form>
          <label>
            <span class="visually-hidden">Varyant</span>
            <select name="id">${variantOptions}</select>
          </label>
          <label>
            <span class="visually-hidden">Adet</span>
            <input type="number" name="quantity" value="1" min="1">
          </label>
          <button class="kv-button primary" type="submit">${kvEscapeHtml(kvTheme.quickAddLabel || 'Sepete ekle')}</button>
          <a class="kv-button" href="${kvEscapeHtml(productUrl)}">${kvEscapeHtml(kvTheme.quickDetailLabel || 'Ürün detayına git')}</a>
        </form>
      </div>
    `;
  } catch (error) {
    content.innerHTML = `
      <div class="kv-editor-empty">
        <strong>${kvEscapeHtml(kvTheme.openErrorLabel || 'Ürün açılamadı')}</strong>
        <span>${kvEscapeHtml(kvTheme.openErrorNoteLabel || 'Ürün detay sayfasından devam edin.')}</span>
        ${fallbackProductUrl !== '#' ? `<a class="kv-button primary" href="${kvEscapeHtml(fallbackProductUrl)}">${kvEscapeHtml(kvTheme.quickDetailLabel || 'Ürün detayına git')}</a>` : ''}
      </div>
    `;
  }
});

document.addEventListener('click', (event) => {
  const close = event.target.closest('[data-quick-close]');
  if (!close) return;

  const drawer = document.querySelector('[data-quick-drawer]');
  if (drawer) drawer.hidden = true;
});

document.addEventListener('change', (event) => {
  const variantSelect = event.target.closest('.kv-quick-form select[name="id"]');
  if (!variantSelect) return;

  const price = variantSelect.selectedOptions[0]?.getAttribute('data-price');
  const priceNode = variantSelect.closest('.kv-quick-product')?.querySelector('[data-quick-price]');
  if (priceNode) priceNode.textContent = kvFormatMoney(price);
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-quick-form]');
  if (!form) return;

  event.preventDefault();
  const button = form.querySelector('button[type="submit"]');
  if (button) button.disabled = true;

  try {
    const formData = new FormData(form);
    const response = await fetch(kvTheme.cartAddUrl || kvRoute('cart/add.js'), {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    });
    if (!response.ok) throw new Error('Cart add failed');
    window.location.href = kvTheme.cartUrl || kvRoute('cart');
  } catch (error) {
    form.submit();
  }
});
